import cn from 'classnames';
import './BallFall.scss';

export const BallFall = (props: Partial<Pick<HTMLDivElement, 'className'>>) => (
	<div className={cn('la-ball-fall', props.className)}>
		<div />
		<div />
		<div />
	</div>
);
